import { serviceGo } from '@/utils/request'

// 平台新增数据：整个平台一组汇总数（非分书）
export interface PlatformNewData {
  new_devices: number       // 新增设备数
  new_users: number         // 新增用户数
  impression_users: number  // N日内有小说列表曝光的人数（≈新增用户数，校验用）
  detail_view_ge1: number   // N日内进入≥1本小说详情页的人数
  detail_view_ge2: number
  detail_view_ge3: number
  enter_ge1: number         // N日内进入≥1本小说剧情的人数
  enter_ge2: number
  enter_ge3: number
  node_ge1: number          // N日内完成（暂为进入去重）≥1个节点的人数
  node_ge2: number
  node_ge3: number
  ai_node_ge1: number       // N日内完成≥1个AI节点的人数
  ai_node_ge2: number
  ai_node_ge3: number
  chapter1_book_ge1: number // N日内完成第1章的书数≥1的人数（dialogues 口径，按 user 跨书聚合）
  chapter1_book_ge2: number // 完成第1章的书数≥2
  chapter2_book_ge1: number // N日内完成第2章的书数≥1的人数
  chapter2_book_ge2: number // 完成第2章的书数≥2
  chapter3_book_ge1: number // N日内完成第3章的书数≥1的人数
  chapter3_book_ge2: number // 完成第3章的书数≥2
  pay0: number              // N日内累计消费能量(果肉)>0 的人数（付费率分子）
  pay10: number             // ≥10 果肉
  pay20: number
  pay30: number
  pay50: number
  pay100: number
  pay300: number
  ad_reward_users: number   // N日内看广告获得果肉>0的人数（看广告充值率分子）
  ad_reward_60: number      // 看广告累计果肉≥60的人数
  ad_reward_cnt5: number    // 看广告次数≥5的人数（与≥60交叉验证）
  recharge_users: number    // N日内有成功支付充值的人数（支付充值率分子）
  recharge_5yuan: number    // N日内累计支付≥5元的人数

  // 充值金额。后端一律以「分」下发，避免浮点误差；展示时除以 100
  ad_view_count: number       // N日内看广告总次数（非人数，同一人看多次都算）
  ad_unit_price_fen: number   // 单次广告折算价值（分）。页面上的「按 X 分算」标注取自它，不写死
  ad_revenue_fen: number      // 总充值金额（广告）= 次数 × 单价
  recharge_amount_fen: number // 总充值金额（充值）= 真实支付成功金额之和
  total_revenue_fen: number   // 总充值金额（全部）= 广告 + 充值
}

export interface PlatformNewDataParams {
  n_days: 0 | 1 | 3 | 7 | 14 | 30  // 注册起第 N 个自然日内的行为（0=注册当天）
  start_date: string               // 注册日期范围起（yyyy-MM-dd，北京时间，闭区间）
  end_date: string                 // 注册日期范围止
  channel: 'toutiao' | 'kuaishou' | 'other' | 'all'
  version: string                  // 版本筛选（如 '1.0.16'，后端缺省 1.0.16）
  version_mode: 'gte' | 'eq'       // gte=该版本及之后 | eq=仅该版本
}

// 拉取平台新增数据（Go 后端，需管理员权限）
export async function getPlatformNewData(params: PlatformNewDataParams): Promise<PlatformNewData> {
  const res = await serviceGo.get('/api_v2/admin/platform-new-data', { params })
  return res.data.data
}

// 版本下拉选项：device 表已上报版本中 ≥1.0.13 的，语义降序（最新在前），新版本自动出现
export async function getAppVersions(): Promise<string[]> {
  const res = await serviceGo.get('/api_v2/admin/app-versions')
  return res.data.data || []
}
